export default __webpack_public_path__ + "29aecb71bfacbaac4ae7a206fd2564f0.png";